import type { AxiosError } from 'axios'
import { getServerErrorCodes } from 'utils/calendarInheritance'

export const EDIT_PARTICIPANTS_USER_NOT_AUTHORIZED = -101
export const EDIT_GROUP_METADATA_USER_NOT_AUTHORIZED = -102
export const EDIT_GROUP_SETTINGS_USER_NOT_AUTHORIZED = -103
export const EDIT_GROUP_USER_NOT_PART_OF_GROUP = -104
export const EDIT_GROUP_ADD_PARTICIPANTS_USER_NOT_ADMIN = -105
export const PARENT_GROUP_DOES_NOT_ALLOW_ADD_MEMBERS = -109
export const OUT_OF_TIER = -110
export const ADD_EVENT_NOT_PART_OF_GROUP = -111
export const ADD_EVENT_CANNOT_POST_ITEMS = -112
export const MULTIPLE_GROUPS_EMBED_WITHOUT_TIER = -113
export const CHILD_OWNER_BELOW_INHERITANCE_TIER = -118
export const EDIT_EVENT_NOT_PART_OF_GROUP = -121
export const EDIT_EVENT_CANNOT_CHANGE_EVENT = -122
export const EDIT_EVENT_CAN_CHANGE_ONLY_OWNERS = -123

// Permission and subscription failures do not invalidate an account session.
export const VALID_403_CODES = [
  EDIT_PARTICIPANTS_USER_NOT_AUTHORIZED,
  EDIT_GROUP_METADATA_USER_NOT_AUTHORIZED,
  EDIT_GROUP_SETTINGS_USER_NOT_AUTHORIZED,
  EDIT_GROUP_USER_NOT_PART_OF_GROUP,
  EDIT_GROUP_ADD_PARTICIPANTS_USER_NOT_ADMIN,
  OUT_OF_TIER,
  PARENT_GROUP_DOES_NOT_ALLOW_ADD_MEMBERS,
  CHILD_OWNER_BELOW_INHERITANCE_TIER,
  ADD_EVENT_NOT_PART_OF_GROUP,
  ADD_EVENT_CANNOT_POST_ITEMS,
  MULTIPLE_GROUPS_EMBED_WITHOUT_TIER,
  EDIT_EVENT_NOT_PART_OF_GROUP,
  EDIT_EVENT_CANNOT_CHANGE_EVENT,
  EDIT_EVENT_CAN_CHANGE_ONLY_OWNERS
]
export function isPermissionOrSubscriptionError(error: AxiosError): boolean {
  return (
    error.response?.status === 403 &&
    getServerErrorCodes(error.response.data).some((code) =>
      VALID_403_CODES.includes(code)
    )
  )
}
